export default __webpack_public_path__ + "static/media/FoundersGrotesk-RegularItalic.0fe64b9f.woff2";